import styled from 'styled-components';

import COLORS from '@ui-component-library/styles/colors';
import { PULSE_HIGHLIGHT_RESET } from '@ui-component-library/styles/components.reset';

export const S = {
  Container: styled.div`
    ${PULSE_HIGHLIGHT_RESET}

    background: ${COLORS['info-500']};
    border-radius: 50%;
    margin: 10px;
    height: 10px;
    width: 10px;

    box-shadow: 0 0 0 0 ${COLORS['info-500']};
    transform: scale(1);
    animation: pulse 2s infinite;

    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 ${COLORS['info-500']};
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
      }
    }
  `
};
